import { createContext, useState } from "react";
export const ProjectContext = createContext()

export const ProjectContextProvider = (props) => {
    const [proOrder, setProOrder] = useState(localStorage.getItem('order') || 'desc'); // desc and asc
    const [proSortField, setProSortField] = useState(localStorage.getItem('sortField') || 'updatedTime'); // updatedTime and projectName
    const [proFunction, setProFunction] = useState('') //项目类型筛选
    const [projectName, setProjectName] = useState()
    // 弹框资源筛选列表
    const [resourceFilter, setResourceFilter] = useState({
        sex: [], // 性别
        age: [], // 年龄
        skin: [], // 肤色
        shoesType: [], // 鞋子品类 
        pose: [], // 姿势
        view: [], // 视角
        clothesCate: [], // 服饰品类
        commodityType: null, // 商品品类 only commodity
        recommendCommodityType: null, // 推荐的商品品类 only commodity
        sceneType: null, // 场景品类 only commodity OR model
    })
    // 项目列表切换tab
    const [tabKey, setTabKey] = useState('1')


    return (
        <ProjectContext.Provider value={{
            proOrder, setProOrder,
            proSortField, setProSortField,
            proFunction, setProFunction,
            projectName, setProjectName,
            resourceFilter, setResourceFilter,
            tabKey, setTabKey
        }}>
            {props.children}
        </ProjectContext.Provider>
    );
}
